import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import type { FormControlValueTypes } from 'ngrx-forms';
import type { SingleFieldExplanationContent } from '@legacy/common-ui-utility-components';
import { SingleFieldStepViewModel } from '@innogy/shared/forms';
import {
  ErrorCardComponent,
  MoreInfoButtonComponent,
} from '@legacy/common-ui-utility-components';

import type { ButtonOptions } from '../button-options/button-options.model';
import { SingleFieldQuestionContent } from '../../interfaces';
import { ProgressiveFormStepBaseComponent } from '../progressive-form-step.base.component';
import { ProgressiveFormService } from '../../progressive-form.service';
import { ProgressiveFormStepWrapperComponent } from '../../progressive-form-step-wrapper/progressive-form-step-wrapper.component';
import { ProgressiveFormBodyDirective } from '../../progressive-form-body.directive';
import { ProgressiveFormValueProgressButtonComponent } from '../../progressive-form-value-progress-button/progressive-form-value-progress-button.component';
import { ProgressiveFormSummaryDirective } from '../../progressive-form-summary.directive';

@Component({
  selector:
    'wl-progressive-step-single-option-question[rendering][progressiveFormSelectorKey][content]',
  templateUrl: './progressive-step-single-option-question.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ProgressiveFormStepWrapperComponent,
    ProgressiveFormBodyDirective,
    ErrorCardComponent,
    ProgressiveFormValueProgressButtonComponent,
    MoreInfoButtonComponent,
    ProgressiveFormSummaryDirective,
  ],
})
export class ProgressiveStepSingleOptionQuestionComponent<
  TFormFieldType extends FormControlValueTypes,
> extends ProgressiveFormStepBaseComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override progressiveFormSelectorKey!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override rendering: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override content!: SingleFieldQuestionContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override formStep?: SingleFieldStepViewModel<TFormFieldType>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() questionOptions?: ButtonOptions[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isReadonly = false;
  @Output()
  override giveMoreInfo: EventEmitter<SingleFieldExplanationContent> =
    new EventEmitter<SingleFieldExplanationContent>();

  constructor(
    override readonly progressiveFormService: ProgressiveFormService
  ) {
    super(progressiveFormService);
  }
}
